export const ROUTE_NAMES = {
  Product: 'Product',
};
